export default {
  state: {
    key: null,
    show: false,
    fromActivityModal: false,
  },
  sequences: {},
};
